import { Button } from "@/components/ui/button";
import { ArrowRight, Briefcase, Building2, Shield, Lock, Award } from "lucide-react";
import { useContext } from "react";
import { CalendlyContext } from "@/App";

const HeroSection = () => {
  const { setIsOpen } = useContext(CalendlyContext);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="pt-32 pb-16 md:pt-36 md:pb-24 bg-gradient-to-br from-emerald-700 to-emerald-900 text-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <div className="animate-fade-in">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-montserrat leading-tight mb-4">
                Redefine Your Business with Advensify's Adaptive AI and Premium Software Solutions
              </h1>
              <p className="text-xl opacity-90 mb-8">
                Empowering Fortune 500s and startups with intelligent automation, predictive insights, and scalable technology.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button 
                  className="bg-white text-emerald-700 hover:bg-gold-500 hover:text-gray-800 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg text-lg py-6 px-8 rounded-md"
                  onClick={() => setIsOpen(true)}
                >
                  <Briefcase className="mr-2 h-5 w-5" />
                  Get a Free Consultation
                </Button>
                <Button 
                  variant="link" 
                  className="text-white hover:text-gold-500 transition-all duration-300 group text-lg py-6"
                  onClick={() => scrollToSection('services')}
                >
                  Explore Our Services
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative animate-float">
              <div className="absolute inset-0 bg-gradient-radial from-emerald-500/30 to-transparent rounded-full blur-3xl"></div>
              <img 
                src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
                alt="Green Technology Building" 
                className="w-full h-auto rounded-2xl shadow-xl relative z-10"
              />
            </div>
          </div>
        </div>
        
        <div className="mt-20 flex flex-wrap justify-center gap-8 opacity-80">
          <div className="flex items-center">
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
              <Building2 className="h-4 w-4 text-white" />
            </div>
            <p className="ml-2 text-sm font-medium">Trusted by FORTUNE 500</p>
          </div>
          <div className="flex items-center">
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
              <Shield className="h-4 w-4 text-white" />
            </div>
            <p className="ml-2 text-sm font-medium">GDPR Compliant</p>
          </div>
          <div className="flex items-center">
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
              <Lock className="h-4 w-4 text-white" />
            </div>
            <p className="ml-2 text-sm font-medium">HIPAA Compliant</p>
          </div>
          <div className="flex items-center">
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
              <Award className="h-4 w-4 text-white" />
            </div>
            <p className="ml-2 text-sm font-medium">ISO 27001 Certified</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
